import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean> = (isExpanded) => ({
  borderRadius: (p) => p.spacing(1),
  borderColor: isExpanded
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.grey[300],
});

export const cardContent: SxStyle = {
  '&.MuiCardContent-root:last-child': { paddingBottom: 1 },
};

export const grid: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const row: SxStyle = {
  padding: (p) => p.spacing(1, 1.5),
  borderRadius: (p) => p.spacing(1),
  background: (p) => p.palette.grey[50],
};

export const checkIcon: SxStyle = {
  color: (p) => p.palette.success[700],
};

export const disabledCheckIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
